import { useState, useEffect, useCallback } from 'react';
import api from '../services/api';

/**
 * Cuenta de mensajes sin leer en /api/messages. La usa el badge de la nav
 * (AppShell) y la pestaña de Bandeja de entrada en Mensajes; `refresh()` se
 * llama también al llegar un `message_received` por WebSocket y al marcar
 * uno como leído, para no esperar al siguiente sondeo.
 *
 * El límite de 50 es el mismo tope que ya usa el endpoint; si algún día hay
 * más de 50 sin leer el badge se queda en 50, que es aceptable para un contador.
 */
function useUnreadMessages(pollMs = 60000) {
  const [count, setCount] = useState(0);

  const refresh = useCallback(() => {
    api.get('/messages', { params: { unread: 1, limit: 50 } })
      .then((res) => setCount(res.data?.messages?.length || 0))
      .catch(() => { /* sin sesión o backend caído: el badge simplemente no sube */ });
  }, []);

  useEffect(() => {
    refresh();
    if (!pollMs) return undefined;
    const id = setInterval(refresh, pollMs);
    return () => clearInterval(id);
  }, [refresh, pollMs]);

  return { count, refresh };
}

export default useUnreadMessages;
